export const KeyboardHandlerKey = Symbol('provideKeyboardHandler')

export const ContainerBreakpointsKey = Symbol('provideContainerBreakpoints')
